// Enviar correo usando el endpoint serverless de DigitalOcean (Brevo)
const ENDPOINT =
  "https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-ec2ce4e6-8560-40de-a928-4358aa461b8f/default/send-contact-mail-form";

const sendMail = async (email, name, company, position, message, antiBot = {}) => {
  try {
    const response = await fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        name,
        company,
        position,
        message,
        honeypot: antiBot.honeypot || "",
        elapsedMs: antiBot.elapsedMs || 0,
      }),
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json().catch(() => null);
    if (data && data.ok === false) {
      return false;
    }

    return true;
  } catch (error) {
    console.error("sendMail error:", error);
    return false;
  }
};

export { sendMail };
